<template>
    <mdb-container fluid>
 
      <mdb-row>
        <mdb-col lg="12" md="12">
  
          <mdb-card class="mb-4">
            <div class="card-header white-text primary-color">آخرین تیکت ها</div>
            <div class="card-body">
              <table class="table no-header mt-1">
                <tbody>
                  <tr
                    v-for="ticket in dashboard.TicketTop"
                    v-bind:key="ticket.TicketId"
                    @click="showTicket(ticket)"
                    class="hover"
                  >
                    <td v-text="ticket.DepartmentName"></td>
                    <td v-text="ticket.Title"></td>
                    <td class="hour">
                      <small>
                        <span class="grey-text float-right notification-clock">
                          <i class="far fa-clock" aria-hidden="true"></i>
                          <span v-text="ticket.LastUpdate"></span>
                        </span>
                      </small>
                    </td>
                  </tr>
                </tbody>
              </table>
  
            </div>
          </mdb-card>
  
        </mdb-col>
  
      </mdb-row>
    </mdb-container>
  </template>
  
  <script>
  import systemApi from "@/api/systemApi";
  
  const userDashboard = () => ({
    WalletAmount: 0,
    ProfitAmount: 0,
    TicketCount: 0,
    TicketNewCount: 0,
    TicketTop: null,
    ServiceCount: 0,
    ActiveServiceCount: 0,
    InvoiceCount: 0,
    NewInvoiceCount: 0,
    InvoiceTop: null,
  });
  
  import {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardBody,
    mdbBtn,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbIcon,
    mdbInput,
    mdbTextarea,
    mdbTab,
    mdbTabItem,
      mdbSelect,
  } from "mdbvue";
  
  export default {
    name: "Dashboard",
    components: {
      mdbContainer,
      mdbRow,
      mdbCol,
      mdbCard,
      mdbCardBody,
      mdbBtn,
      mdbModal,
      mdbModalHeader,
      mdbModalTitle,
      mdbModalBody,
      mdbModalFooter,
      mdbIcon,
      mdbInput,
      mdbTextarea,
      mdbTab,
      mdbTabItem,
      mdbSelect,
    },
    data() {
      return {
        dashboard: userDashboard(),
        services: null,
        serviceType: 1
      };
    },
    methods: {
      showAllTicket() {
        this.$router.push({ name: "Tickets" });
      },
      showAllInvoice() {
        this.$router.push({ name: "Invoices" });
      },
      showAllService() {
        this.$router.push({ name: "Services" });
      },
      showAllTransactions() {
        this.$router.push({ name: "Wallet" });
      },
      showAllAnnouncement() {
        this.$router.push({ name: "Announcements" });
      },
      showTicket(ticket){
        this.$router.push({name: 'Ticket', params: { ticketId: ticket.TicketId }});
      },
      showInvoice(invoice){
        // console.log("invoice",invoice);
        this.$router.push({name: 'Invoice', params: { invoiceId: invoice.InvoiceId }});
      },
      orderPackage(userPackage){
        this.$router.push({name: 'Request', params: { type: 'Package', id:userPackage.PackageId }});
      },
      selectService(value,text) {
        this.serviceType = value;
        console.log(value, text);
      },
      requestService(){
        this.$router.push({name: 'Request', params: { type: "Service",id:this.serviceType}});
      }
    },
    mounted() {
      console.log("mounted");
      this.form.RequestType = this.$route.params.type;

      this.dashboard = this.$store.state.dashboard;
      systemApi.getDashboard().then(
        ({ data }) => {
          this.$store.state.dashboard = data;
          this.dashboard = this.$store.state.dashboard;
  
          this.services = [];
          for(var i = 0; i < this.dashboard.ServiceType.length; i++) {
            this.services.push({
              text: this.dashboard.ServiceType[i].Text,
              value: this.dashboard.ServiceType[i].Value,
              selected: this.dashboard.ServiceType[i].Value == this.serviceType
            });
          }
        },
        (r) => {}
      );
    },
  };
  </script>
  
  <!-- Add 'scoped" attribute to limit CSS to this component only -->
  <style scoped>
  .m-0 {
    margin: 0;
  }
  </style>
  